export default "__VITE_ASSET__CixNS5Jv__"